import React, { Component } from 'react';
import PlacesAutoComplete from 'Components/PlacesAutoComplete';
import { ReactComponent as AddIcon } from "Icons/new-plus.svg";
import {ReactComponent as DeleteIcon} from 'Icons/delete.svg';
import ResponsiveTable from "Components/ResponsiveTable";
import { TAT_UNITS } from 'Constants/commonConstants';
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown/dropdown';
import Cx from 'classnames';


class LCLTrips extends Component {
    constructor() {
        super();
        this.state = {

        }
    }
    renderTripsOrSearchedTrips=()=>{
        const { trips,searchText,searchedSecondaryCotractRfqTrips} = this.props;
        if(!!searchText){
            return searchedSecondaryCotractRfqTrips;
        }
        return trips;   
    }
    
    render() {
        const { trips, onChangeTrips, contractTypeId, pricingBasis,  isView, isEdit, data,searchText,searchedSecondaryCotractRfqTrips} = this.props;
        let symbolsArr = ["e", "E", "+", "-", "."];
        return (
            <div className={'mt-20 ht-90 pv-20 ph-20 bg-white br-5 lcl-contract-trips'} style={{'border': '1px solid #85919E'}}>
                <div className='content-bgColor pt-20 ph-10 mt-5 br-2 col-1'>
                <input placeholder={"Search Trips"} 
                            type="text" 
                            className="mr-30 wt-200 br-20 ht-40 bg-gray search"
                            value={searchText}
                            onChange={this.props.onSearchTrip}
                        />
                    <ResponsiveTable>
                    <table className='trip-table-secondary mb-50' cellspacing={'10px'}>
                        <tr>
                            <th width="200">From City <span style={{ color: 'red' }}>*</span></th>
                            <th width="150">From State <span style={{ color: 'red' }}>*</span></th>
                            <th width="150">From Zone <span style={{ color: 'red' }}>*</span></th>
                            <th width="200">To City <span style={{ color: 'red' }}>*</span></th>
                            <th width="150">To State <span style={{ color: 'red' }}>*</span></th>
                            <th width="150">To Zone <span style={{ color: 'red' }}>*</span></th>
                            <th width="150">Pincode</th>
                            <th width="100">Rate (₹) <span style={{ color: 'red' }}>*</span></th>
                            <th width="200">TAT {(contractTypeId === 1 ? data.tat_master_applicable : true) && <span style={{ color: 'red' }}>*</span>}</th>
                            {contractTypeId === 2 && <>
                                <th width="300">Minimum Quantity</th>
                                <th width="200">Variable Cost (₹)</th>
                                <th width="300">Variable Qunatity</th>
                            </>}
                            {!isView && <th className='last'></th>}
                        </tr>
                        <>
                        {(this.renderTripsOrSearchedTrips() || []).map((trip, tripIndex) => {
                            const stop = (trip.stops || []);
                            const tripId = trip.trip_id
                        return(<tr>
                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                {contractTypeId === 1 ? 
                                    <Input 
                                        className={'border-dblue br-2'}
                                        placeholder={'City'}
                                        value={(stop[0] || {}).location || ''}
                                        onChange={(e) => onChangeTrips(tripIndex, 'fromCity', e)}
                                    /> :
                                 <PlacesAutoComplete  
                                    inputClassName={'border-dblue br-2'}
                                    setLocation={onChangeTrips.bind(this, tripIndex, 'from')}
									value={(stop[0] || {}).location || ''}
                                />}
                            </td>
                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                <Input 
                                    className={'border-dblue br-2'}
                                    placeholder={'State'}
                                    value={(stop[0] || {}).state}
                                    onChange={(e) => onChangeTrips(tripIndex, 'fromState', e)}
                                    readOnly={contractTypeId === 1 ? false : true}
                                />
                            </td>
                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                <Input 
                                    className={'border-dblue br-2'}
                                    placeholder={'Zone'}
                                    value={trip.from_zone}
                                    onChange={(e) => onChangeTrips(tripIndex, 'from_zone', e)}
                                />
                            </td>
                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                {contractTypeId === 1 ? 
                                    <Input 
                                        className={'border-dblue br-2'}
                                        placeholder={'City'}
                                        value={(stop[1] || {}).location || ''}
                                        onChange={(e) => onChangeTrips(tripIndex, 'toCity', e)}
                                    /> :
                                <PlacesAutoComplete  
                                    inputClassName={'border-dblue br-2'}
                                    setLocation={onChangeTrips.bind(this, tripIndex, 'to')}
									value={(stop[1] || {}).location || ''}
                                />}
                            </td>
                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                <Input  
                                    className={'border-dblue br-2'}
                                    placeholder={'State'}
                                    value={(stop[1] || {}).state}
                                    onChange={(e) => onChangeTrips(tripIndex, 'toState', e)}
                                    readOnly={contractTypeId === 1 ? false : true}
                                />
                            </td>
                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                <Input  
                                    className={'border-dblue br-2'}
                                    placeholder={'Zone'}
                                    value={trip.to_zone}
                                    onChange={(e) => onChangeTrips(tripIndex, 'to_zone', e)}
                                />
                            </td>
                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                <Input  
                                    type="number"
                                    className={'border-dblue br-2'}
                                    placeholder={'Pincode'}
                                    value={trip.to_pincode}
                                    onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                    onChange={(e) => onChangeTrips(tripIndex, 'to_pincode', e)}
                                />
                            </td>
                            <td className={Cx('', {'disable-pointer-events': isView})}> 
                                <Input  
                                    className={'border-dblue br-2 wt-100'}
                                    type={'number'}
                                    placeholder={'Rate'}
                                    value={trip.qbr}
                                    onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                    onChange={(e) => onChangeTrips(tripIndex, 'qbr', e)}
                                /> 
                            </td>
                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                <div className='flex'>
                                    <Input  
                                        className={'border-dblue br-2 wt-100 mr-5'}
                                        type={'number'}
                                        placeholder={'TAT'}
                                        value={(trip.tat || {}).value}
                                        onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                        onChange={(e) => onChangeTrips(tripIndex, 'tat', {
                                            "unit": (trip.tat || {}).unit,
                                            "value": +e.target.value,
                                            "name": (trip.tat || {}).name
                                        })
                                        }
                                    />
                                    <Dropdown 
                                        items={TAT_UNITS}
                                        displayKey={"name"}
                                        // widthValue={'wt-200'}
                                        className="border-dblue bg-white"
                                        name="tat_unit" 
                                        label="Select"
                                        selectedItem={(trip.tat || {}).unit && TAT_UNITS.find(el => (el.value == ((trip.tat || {}).unit)))}
                                        onSelect={(optionValue) => onChangeTrips(tripIndex, 'tat', {
                                            "unit": (TAT_UNITS.find(el => el.name == optionValue) || {}).value,
                                            "value": (trip.tat || {}).value,
                                            "name": optionValue
                                        })
                                        }
                                    />
                                </div>
                            </td>
                            {contractTypeId === 2 && <>
                                <td className={Cx('', {'disable-pointer-events': isView})}>
                                    <div className='flex'>
                                    <Input  
                                        className={'border-dblue br-2 wt-120 mr-5'}
                                        type={'number'}
                                        placeholder={'Quantity'}
                                        value={trip.minimum_quantity}
                                        onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                         onChange={(e) => onChangeTrips(tripIndex, 'minimum_quantity', e)}
                                        
                                    />
                                    <Dropdown 
                                        items={pricingBasis}
                                        displayKey={"name"}
                                        // widthValue={'wt-400'}
                                        className="border-dblue bg-white"
                                        name="minimum_quantity_uom" 
                                        label="Select"
                                        selectedItem={trip.minimum_quantity_uom && pricingBasis.find(el => el.name == trip.minimum_quantity_uom)}
                                        onSelect={(optionValue) => onChangeTrips(tripIndex, 'minimum_quantity_uom', optionValue)
                                        }
                                    />
                                    </div>
                                </td>
                                <td className={Cx('', {'disable-pointer-events': isView})}>
                                    <Input  
                                        className={'border-dblue br-2'}
                                        type={'number'}
                                        placeholder={'Cost'}
                                        value={trip.variable_cost}
                                        onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                        onChange={(e) => onChangeTrips(tripIndex, 'variable_cost', e)}
                                    />
                                </td>
                                <td className={Cx('', {'disable-pointer-events': isView})}>
                                    <div className='flex'>
                                        <Input  
                                            className={'border-dblue br-2 wt-120 mr-5'}
                                            type={'number'}
                                            placeholder={'Quantity'}
                                            value={trip.variable_quantity}
                                            onKeyDown={e => (symbolsArr.includes(e.key)) && e.preventDefault()}
                                            onChange={(e) => onChangeTrips(tripIndex, 'variable_quantity', e)}
                                            
                                        />
                                        <Dropdown 
                                            items={pricingBasis}
                                            displayKey={"name"}
                                            // widthValue={'wt-400'}
                                            className="border-dblue bg-white"
                                            name="variable_quantity_uom" 
                                            label="Select"
                                            selectedItem={trip.variable_quantity_uom && pricingBasis.find(el => el.name == trip.variable_quantity_uom)}
                                            onSelect={(optionValue) => onChangeTrips(tripIndex, 'variable_quantity_uom', optionValue)
                                            }
                                        />
                                    </div>
                                </td>
                            </> || ''}
                            {!isView && <td className='last'>
                                <div className='flex'>
                                    {!isEdit && trips.length > 1 && <DeleteIcon className='wt-18 ht-18 mr-5 curP fBold' onClick={() => this.props.onDeleteTrip(tripIndex)}/>}
                                    {isEdit && <DeleteIcon className='wt-18 ht-18 mr-5 curP fBold' onClick={() => this.props.onEditDeleteTrip(tripId,tripIndex)}/>}
                                    <AddIcon  onClick={() => this.props.onAddTrip()}/>
                                </div>
                            </td>}
                        </tr>)})}
                        </>
                    </table>
                    </ResponsiveTable>
                </div>
            </div>
        )
    }
}

export default LCLTrips;